import { Button, Box } from '@material-ui/core';
import { Modal, Alert, Typography } from '@components';
import { textTemplate } from '@utils';
import { content } from '@content';
import { useStyles } from './ExperienceLeavingWarningModal.styles';
import { ExperienceLeavingWarningModalProps } from './ExperienceLeavingWarningModal.props';

export const ExperienceLeavingWarningModal = ({
  name,
  onClose,
  onCancel,
  onConfirm,
}: ExperienceLeavingWarningModalProps): JSX.Element => {
  const styles = useStyles();

  return (
    <Modal open onClose={onClose} maxWidth="42.7rem">
      <Alert className={styles.warning} message={content.warning} />
      <Typography.Body
        className={styles.message}
        dangerouslySetInnerHTML={{
          __html: textTemplate(content.moduleGroupLeavingWarning, { name }),
        }}
      />
      <Box>
        <Button variant="contained" color="primary" className={styles.confirm} onClick={onConfirm}>
          {content.yes}
        </Button>
        <Button variant="outlined" color="primary" onClick={onCancel}>
          {content.noCancel}
        </Button>
      </Box>
    </Modal>
  );
};
